import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ModalComponent from '../layout/Modals/ModalComponent/ModalComponent';
import { connectModalContainerContextToComponent } from '../../contexts/ModalContext/ModalContext';

function DeleteConfirmationModal(props) {
  const {
    setModalJSX,
    itemName,
    handleDelete,
    isButtonDisabled,
  } = props;
  const [show, setShow] = useState(true);
  const closeModalHandler = () => {
    setShow(false);
    setModalJSX((<></>));
  };

  return (
    <ModalComponent
      show={show}
      close={closeModalHandler}
      showConfirmCallToAction
      confirmButtonAction={handleDelete}
      confirmButtonText="Delete"
      isBtnDisabled={isButtonDisabled}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Delete
          {' '}
          {itemName}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col">
            <p>
              Are you sure you want to delete
              {' '}
              {itemName}
              ?
            </p>
          </div>
        </div>
      </Modal.Body>
    </ModalComponent>
  );
}

DeleteConfirmationModal.propTypes = {
  setModalJSX: PropTypes.func.isRequired,
  itemName: PropTypes.string.isRequired,
  handleDelete: PropTypes.func.isRequired,
  isButtonDisabled: PropTypes.bool.isRequired,
};

export default connectModalContainerContextToComponent(DeleteConfirmationModal);
